<h4>Agregar Registro de Estado</h4>
<form [formGroup]="reactiveForm" (ngSubmit)="(submitForm)" class="smart-form">
  <fieldset>
    <div class="row">
      <dynamic-form
        class="form-registration"
        [formInputs]="dinamicFormInputsData"
        [suggestedNumberCols]="1"
        [templateInputsExternal]="{
          registrationArea: registrationAreaTemplate,
          subArea: subAreaTemplate,
          alertType: alertTypeTemplate,
          registerType: registerTypeTemplate,
          idStatus: idStatusTemplate,
          sistemaBloquear: sistemaBloquearTemplate,
          observation: observationTemplate
        }">
      </dynamic-form>

      <ng-template #registrationAreaTemplate>
        <div class="col-xs-12">
          <label class="label">Área</label>
          <label class="select">
            <select
              class="formControl"
              formControlName="registrationArea"
              (click)="updateAreaDependingFields()">
              <option *ngFor="let area of allAreas" [value]="area.cdOption">
                {{ area.label }}
              </option>
            </select>
            <i></i>
          </label>
          <div
            *ngIf="
              reactiveForm.get('registrationArea').invalid &&
              reactiveForm.get('registrationArea').touched
            ">
            <p class="error">El area registrante es obligatorio</p>
          </div>
        </div>
      </ng-template>

      <ng-template #subAreaTemplate>
        <div class="col-xs-12">
          <label class="label">Sub Área</label>
          <label class="select">
            <select
              class="formControl"
              formControlName="subArea"
              (click)="getOptionSubArea()"
              [disabled]="!subAreaLoaded">
              <option [ngValue]="null" disabled selected hidden>
                Seleccione una opción
              </option>
              <option
                *ngFor="let subArea of currentSubareas"
                [value]="subArea.cdOption">
                {{ subArea.label }}
              </option>
            </select>
            <i>
              <p class="text-center" *ngIf="isLoadingSubarea">
                <img src="assets/img/loading2.gif" alt="" />
              </p>
            </i>
          </label>
          <div
            *ngIf="
              reactiveForm.get('subArea')?.invalid &&
              (reactiveForm.get('subArea')?.touched ||
                reactiveForm.get('subArea')?.dirty)
            ">
            <p class="error">El sub area es obligatorio</p>
          </div>
        </div>
      </ng-template>

      <ng-template #alertTypeTemplate>
        <div class="col-xs-12">
          <label class="label">Tipo de alerta</label>
          <label class="select">
            <select
              class="formControl"
              formControlName="alertType"
              (click)="getOptionAlertType()">
              <option [ngValue]="null" disabled selected hidden>
                Seleccione una opción
              </option>
              <option
                *ngFor="let alertType of currentAlertTypes"
                [value]="alertType.cdOption">
                {{ alertType.label }}
              </option>
            </select>
            <i>
              <p class="text-center" *ngIf="loadingImgAlertType">
                <img src="assets/img/loading2.gif" alt="" />
              </p>
            </i>
          </label>
          <div *ngIf="reactiveForm.value.alertType === 'Otro'">
            <div class="form-group">
              <label class="label"> Motivo </label>
              <input
                class="form-control"
                formControlName="motivo"
                placeholder="Ingrese su motivo" />
            </div>
            <div
              *ngIf="
                reactiveForm.get('motivo')?.invalid &&
                (reactiveForm.get('motivo')?.touched ||
                  reactiveForm.get('motivo')?.dirty)
              ">
              <p class="error">
                El motivo no puede tener mas de 300 caracteres
              </p>
            </div>
          </div>
          <div
            *ngIf="
              reactiveForm.get('alertType')?.invalid &&
              (reactiveForm.get('alertType')?.touched ||
                reactiveForm.get('alertType')?.dirty)
            ">
            <p class="error">El tipo de alerta es obligatorio</p>
          </div>
        </div>
      </ng-template>

      <ng-template #registerTypeTemplate>
        <div class="col-xs-12">
          <label class="label">Tipo de registro</label>
          <label class="select">
            <select class="formControl" formControlName="registerType" disabled>
              <option [ngValue]="null" disabled selected hidden>
                Seleccione una opción
              </option>
              <option
                *ngFor="let registerType of currentRegisterType"
                [value]="registerType.cdOption">
                {{ registerType.label }}
              </option>
            </select>
            <i>
              <p class="text-center" *ngIf="loadingImgRegisterType">
                <img src="assets/img/loading2.gif" alt="" />
              </p>
            </i>
            <div
              *ngIf="
                reactiveForm.get('registerType')?.invalid &&
                (reactiveForm.get('registerType')?.touched ||
                  reactiveForm.get('registerType')?.dirty)
              ">
              <p class="error">El tipo de registro es obligatorio</p>
            </div>
          </label>
        </div>
      </ng-template>

      <ng-template #idStatusTemplate>
        <div class="col-xs-12">
          <label class="label">Estados </label>
          <label class="select">
            <select class="formControl" formControlName="idStatus">
              <option
                *ngFor="let status of idStatusListCopy"
                [value]="status.idStatus">
                {{ status.nameStatus }}
              </option>
            </select>
            <i></i>
          </label>
          <div
            *ngIf="
              reactiveForm.get('idStatus').invalid &&
              reactiveForm.get('idStatus').touched
            ">
            <p class="error">El estado es obligatorio</p>
          </div>
        </div>
      </ng-template>

      <ng-template #sistemaBloquearTemplate>
        <div class="col-xs-12">
          <label class="label">Sistema a Bloquear</label>
          <div class="checkbox-group">
            <div
              *ngFor="let sistemaBloquear of sistemasBloquear"
              class="checkbox-item">
              <label>
                <input
                  type="checkbox"
                  [value]="sistemaBloquear.cdOption"
                  (change)="onCheckboxChange($event, sistemaBloquear.cdOption)"
                  [checked]="reactiveForm.get('sistemaBloquear').value?.includes(sistemaBloquear.cdOption)" />
                {{ sistemaBloquear.label }}
              </label>
            </div>
          </div>
          <div
            *ngIf="
              reactiveForm.get('sistemaBloquear').invalid &&
              reactiveForm.get('sistemaBloquear').touched
            ">
            <p class="error">El sistema a bloquear es obligatorio</p>
          </div>
        </div>
      </ng-template>

      <ng-template #observationTemplate>
        <div class="col-xs-12">
          <div class="form-group">
            <label class="label"> Observación </label>
            <input class="form-control" formControlName="observation" />
          </div>
        </div>
        <div
          *ngIf="
            reactiveForm.get('observation').invalid &&
            reactiveForm.get('observation').touched
          ">
          <p class="error">
            La observación no puede tener mas de 300 caracteres
          </p>
        </div>
      </ng-template>

      <div class="col-xs-12 col-md-6">
        <div class="col-md-2 pull-right" *ngIf="loadingImg">
          <p class="text-center">
            <img src="assets/img/loading2.gif" alt="" /> Cargando ...
          </p>
        </div>
      </div>
    </div>
    <button
      class="btn btn-info"
      *ngIf="showSubmit"
      [disabled]="reactiveForm.invalid"
      (click)="submitForm()">
      Ingresar Registro
    </button>
  </fieldset>
</form>
